import { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";

// Module-level cache so every PlatformLogo instance on a page shares one fetch.
let _cachedLogoUrl = null; // null = not fetched yet, "" = fetched, no custom logo set
let _fetchPromise = null;

function fetchPlatformLogo() {
  if (_fetchPromise) return _fetchPromise;
  _fetchPromise = api
    .get("/public/platform-content")
    .then(({ data }) => {
      _cachedLogoUrl = data?.logo_url || "";
      return _cachedLogoUrl;
    })
    .catch(() => {
      _cachedLogoUrl = "";
      return _cachedLogoUrl;
    });
  return _fetchPromise;
}

/**
 * Renders the platform-wide StudioMV logo image if a super-admin has configured one
 * (Super-Admin → Landing → Logo), otherwise falls back to `children` (the existing
 * Scissors-icon + "StudioMV" text mark, or whatever else a given page currently shows).
 */
export default function PlatformLogo({ imgClassName = "h-8 w-auto object-contain", imgStyle, children }) {
  const [logoUrl, setLogoUrl] = useState(_cachedLogoUrl);

  useEffect(() => {
    if (_cachedLogoUrl !== null) return;
    let alive = true;
    fetchPlatformLogo().then((url) => {
      if (alive) setLogoUrl(url);
    });
    return () => {
      alive = false;
    };
  }, []);

  if (logoUrl) {
    return <img src={fileUrl(logoUrl)} alt="StudioMV" className={imgClassName} style={imgStyle} />;
  }
  return children;
}
